/** True in a browser (and jsdom); false in a Node script such as the PDF export. */
export function isBrowser(): boolean {
  return "document" in globalThis;
}
